<template>
  <div class="user_info_container_content">
    <div class="title_top_hr">
      <p>
        <i></i>
        <span>账户管理</span>
      </p>
      <el-divider></el-divider>
    </div>
    <div class="personal_security_box"
    v-loading
    >
      <div class="personal_security_item">
        <p class="personal_security_left">
           <i :class="user.account_name === '' ? 'el-icon-warning my_warning' : 'el-icon-success my_success'"></i>
          <span>登录账号：</span>
        </p>
        <div class="personal_security_right">
          <p v-if="user.account_name === ''" class="lf">未设置</p>
          <p v-else class="lf">{{user.account_name}}</p>
          <el-button v-if="user.account_name === ''" class="rt" type='text' @click="openDialog('accountName')">设置</el-button>
        </div>
      </div>
      <div class="personal_security_item">
        <p class="personal_security_left">
           <i :class="user.is_pass === 0 ? 'el-icon-warning my_warning' : 'el-icon-success my_success'"></i>
          <span>登录密码：</span>
        </p>
        <div class="personal_security_right">
          <p v-if="user.is_pass === 0" class="lf">未设置</p>
          <p v-else class="lf">已设置</p>
          <el-button class="rt" type='text' @click="openDialog('password')">修改</el-button>
        </div>
      </div>
      <div class="personal_security_item">
        <p class="personal_security_left">
          <i class="el-icon-success my_success"></i>
          <span>绑定手机：</span>
        </p>
        <div class="personal_security_right">
          <p class="lf">{{telFilter(user.tel)}}</p>
          <el-button class="rt" type='text' @click="openDialog('tel')">更换手机号</el-button>
        </div>
      </div>
      <div class="personal_security_item">
        <p class="personal_security_left">
          <i :class="user.email === null ? 'el-icon-warning my_warning' : 'el-icon-success my_success'"></i>
          <span>绑定邮箱：</span>
        </p>
        <div class="personal_security_right">
          <p v-if="user.email === null" class="lf">未设置</p>
          <p v-else class="lf">{{emailFilter(user.email)}}</p>
          <el-button class="rt" type='text' @click="openDialog('email')">修改</el-button>
        </div>
      </div>
      <div class="personal_security_item">
        <p class="personal_security_left">
          <i class="el-icon-success my_success"></i>
          <span style="letter-spacing: 4px;">邀请码：</span>
        </p>
        <div class="personal_security_right">
          <p class="lf">{{user.invitation_code}}</p>
          <el-button class="rt" type='text'>已成功邀请 {{user.invitation_count}} 人</el-button>
        </div>
      </div>
      <div class="personal_security_item personal_security_item_three">
        <p class="personal_security_left">
          <span>绑定第三方账号：</span>
        </p>
        <div class="personal_security_right">
          <dl>
            <dt><i class="iconfont icon-weixin" @click="bindThree('weixin')"></i></dt>
            <dd>
              <a v-if="user.weixin === null" @click="bindThree('weixin')">绑定微信<br></a>
              <span v-else>{{user.weixin}}<br></span>
              <el-button v-if="user.weixin !== null" type="text" @click="unBind('weixin')">（解绑）</el-button>
            </dd>
          </dl>
          <dl>
            <dt><i class="iconfont icon-weibo" @click="bindThree('weibo')"></i></dt>
            <dd>
              <a v-if="user.weibo === null" @click="bindThree('weibo')">绑定微博<br></a>
              <span v-else>{{user.weibo}}<br></span>
              <el-button v-if="user.weibo !== null" type="text" @click="unBind('weibo')">（解绑）</el-button>
            </dd>
          </dl>
          <dl>
            <dt><i class="iconfont icon-qq" @click="bindThree('qq')"></i></dt>
            <dd>
              <a v-if="user.qq === null" @click="bindThree('qq')">绑定QQ<br></a>
              <span v-else>{{user.qq}}<br></span>
              <el-button v-if="user.qq !== null" type="text" @click="unBind('qq')">（解绑）</el-button>
            </dd>
          </dl>
        </div>
      </div>
      <!-- 修改弹窗 -->
      <el-dialog title="账号安全验证" :visible.sync="dialogSecurity" width="500px" @close="closeDialog('securityForm')">
        <div class="personal_security_layer">
          <el-form :model="user" :rules="rules" ref="securityForm">
            <div class="personal_security_layer_top">
              <el-form-item label="绑定手机" :label-width="formLabelWidth">
                <span>{{telFilter(user.tel)}}</span>
                <el-button v-if="isCodeShow.security" type="primary" @click="obtain('security')">获取验证码</el-button>
                <span v-else >{{secondsCount.security}}s 后重新发送</span>
              </el-form-item>
              <el-form-item label="验证码" prop="code" :label-width="formLabelWidth">
                <el-input v-model="user.code"></el-input>
              </el-form-item>
            </div>
            <div class="personal_security_layer_bottom">
              <!-- 修改账号 -->
              <div v-if="dialogType === 'accountName'">
                <el-form-item label="账号" :label-width="formLabelWidth" prop="account_name">
                  <el-input v-model="user.account_name" placeholder="以字母开头，只能包含字母、数字、下划线、减号"></el-input>
                </el-form-item>
              </div>
              <!-- 修改密码 -->
              <div v-if="dialogType === 'password'">
                <el-form-item label="新密码" :label-width="formLabelWidth" prop="password">
                  <el-input v-model="user.password" type="password"></el-input>
                </el-form-item>
                <el-form-item label="确认密码" :label-width="formLabelWidth" prop="repeat_password">
                  <el-input v-model="user.repeat_password" type="password"></el-input>
                </el-form-item>
              </div>
              <!-- 修改手机 -->
              <div v-if="dialogType === 'tel'">
                <el-form-item label="绑定手机" :label-width="formLabelWidth">
                  {{telFilter(user.tel)}}
                </el-form-item>
                <el-form-item label="新手机" class="personal_security_code" :label-width="formLabelWidth" prop="new_tel">
                  <el-input v-model="user.new_tel"></el-input>
                  <p>
                    <el-button v-if="isCodeShow.tel" @click="obtain('tel')">发送验证码</el-button>
                    <span v-else >{{secondsCount.tel}}s 后重新发送</span>
                  </p>
                </el-form-item>
                <el-form-item label="验证码" :label-width="formLabelWidth" prop="telCode">
                  <el-input v-model="user.telCode"></el-input>
                </el-form-item>
              </div>
              <!-- 修改邮箱 -->
              <div v-if="dialogType === 'email'">
                <el-form-item v-if="user.email !== null" label="绑定邮箱" :label-width="formLabelWidth">
                  {{emailFilter(user.email)}}
                </el-form-item>
                <el-form-item label="新邮箱" class="personal_security_code" :label-width="formLabelWidth" prop="new_email">
                  <el-input v-model="user.new_email"></el-input>
                  <p>
                    <el-button v-if="isCodeShow.email" @click="obtain('email')">发送验证码</el-button>
                    <span v-else >{{secondsCount.email}}s 后重新发送</span>
                  </p>
                </el-form-item>
                <el-form-item label="验证码" :label-width="formLabelWidth" prop="emailCode">
                  <el-input v-model="user.emailCode"></el-input>
                </el-form-item>
              </div>
            </div>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogSecurity = false">取 消</el-button>
          <el-button type="primary" @click="submitForm('securityForm')">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      // 表单是否显示红色星号标记
      requiredAsterisk: true,
      // 手机验证弹窗的弹出判断
      dialogSecurity: false,
      dialogType: '',
      // 手机验证弹窗的label宽度
      formLabelWidth: '80px',
      // 倒计秒数初始化定义
      secondsCount: {
        security: 60,
        passWord: 60,
        email: 60,
        tel: 60
      },
      // 是否显示发送验证码按钮
      isCodeShow: {
        security: true,
        passWord: true,
        email: true,
        tel: true
      },
      threeUrl: '', // 第三方弹窗地址
      user: {
        account_name: '', // 账号信息
        is_pass: 0, // 是否设置密码
        old_tel: '', // 旧手机
        tel: '', // 绑定手机
        code: '', // 手机验证码
        password: '', // 新密码
        repeat_password: '', // 确认新密码
        new_tel: '', // 新手机
        telCode: '', // 新手机验证码
        email: null, // 绑定邮箱
        new_email: '', // 新邮箱
        emailCode: '', // 新邮箱验证码
        qq: null, // 绑定QQ号
        weixin: null, // 绑定微信
        weibo: null // 绑定微博
      },
      rules: {
        code: [
          {
            validator: (rule, value, callback) => {
              if (value.length === 0) {
                callback(new Error('请输入手机验证码'))
              } else {
                callback()
              }
            }
          }
        ],
        account_name: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 8, max: 16, message: '长度在 8 到 16 个字符', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              const regexp = /^[A-Za-z]{1}[A-Za-z0-9_-]{3,15}$/
              if (!regexp.test(value)) {
                callback(new Error('用户名格式以字母开头，只能包含字母、数字、下划线、减号'))
              } else {
                callback()
              }
            }
          }
        ],
        password: [
          {
            validator: (rule, value, callback) => {
              if (this.dialogType === 'password') {
                if (value.length === 0) {
                  callback(new Error('请输入新密码'))
                } else if (value.length < 8) {
                  callback(new Error('密码长度最少8位'))
                } else {
                  callback()
                }
              }
            }
          }
        ],
        repeat_password: [
          {
            validator: (rule, value, callback) => {
              if (this.dialogType === 'password') {
                if (value.length === 0) {
                  callback(new Error('请再次确认密码'))
                } else if (value === this.user.password) {
                  callback()
                } else {
                  callback(new Error('两次输入密码不一致'))
                }
              }
            }
          }
        ],
        new_tel: [
          {
            validator: (rule, value, callback) => {
              if (this.dialogType === 'tel') {
                if (value.length === 0) {
                  callback(new Error('请输入手机号码'))
                } else if (value.length > 11 || value.length < 8) {
                  callback(new Error('长度必须为11数字'))
                } else {
                  const regexp = /^1[3456789]\d{9}$/
                  if (!regexp.test(value)) {
                    callback(new Error('电话号码格式不对'))
                  } else {
                    callback()
                  }
                }
              }
            }
          }
        ],
        telCode: [
          {
            validator: (rule, value, callback) => {
              if (this.dialogType === 'tel') {
                if (value.length === 0) {
                  callback(new Error('请输入手机验证码'))
                } else {
                  callback()
                }
              }
            }
          }
        ],
        new_email: [
          {
            validator: (rule, value, callback) => {
              if (this.dialogType === 'email') {
                if (value.length === 0) {
                  callback(new Error('请输入邮箱'))
                } else {
                  callback()
                }
              }
            }
          }
        ],
        emailCode: [
          {
            validator: (rule, value, callback) => {
              if (this.dialogType === 'email') {
                if (value.length === 0) {
                  callback(new Error('请输入邮箱验证码'))
                } else {
                  callback()
                }
              }
            }
          }
        ]
      }
    }
  },
  created () {
    this.isThree() // 判断是否为第三方回调页面
    this.getInfo() // 获取绑定信息
  },
  methods: {
    // 初始加载判断是否为第三方登录页面
    isThree () {
      const url = window.location.toString()
      const arrUrl = url.split('?')
      if (arrUrl.length > 1) { // 第三方平台的回调页面
        const para = arrUrl[1]
        const obj = this.getSearchString('code', para)
        if (obj.state === undefined) { // 微博第三方
        } else { // 微信第三方
          this.webWeChatLogin(obj.code)
        }
      }
    },
    // 发送第三方code获取信息
    getSearchString (key, search) {
      const str = search
      const arr = str.split('&')
      const obj = {}
      for (let i = 0; i < arr.length; i++) {
        const tmpArr = arr[i].split('=')
        obj[decodeURIComponent(tmpArr[0])] = decodeURIComponent(tmpArr[1])
      }
      return obj
    },
    // // 获取微信登录信息
    bingWeChat (code) {
      const vueThat = this
      vueThat.myApi.bingWeChat({ code: code }).then((res) => {
        if (res.data.code === 200) {
          vueThat.user.weixin = res.data.data.nickname
        }
      })
    },
    // 手机号过滤
    telFilter (num) {
      const str = num.substring(3, 7)
      return num.replace(str, '****')
    },
    accountNameFilter (num) {
      const str = num.substring(3, num.length - 3)
      return num.replace(str, '****')
    },
    // 邮箱过滤
    emailFilter (num) {
      const str = num.substring(3, 7)
      return num.replace(str, '****')
    },
    // 获取绑定信息
    getInfo () {
      const vueThat = this
      vueThat.myApi.getUserBindInfo().then((res) => {
        if (res.data.code === 200) {
          const data = res.data.data
          for (const key in data) {
            vueThat.user[key] = data[key]
          }
          if (vueThat.user.account_name === vueThat.user.tel) {
            vueThat.user.account_name = ''
          }
        }
      })
    },
    // 验证弹窗显示
    openDialog (type) {
      this.dialogSecurity = true
      this.dialogType = type
    },
    // 验证码倒计时
    codeTime (type) {
      const vueThat = this
      let onOff = true
      if (type === 'tel' || type === 'security') {
        let data = ''
        if (type === 'tel') {
          data = vueThat.user.new_tel
        } else {
          data = vueThat.user.tel
        }
        if (data.length > 11 || data.length < 8) {
          vueThat.$message.error('获取失败，请输入正确的手机号码')
          onOff = false
        } else {
          const regexp = /^1[3456789]\d{9}$/
          if (!regexp.test(data)) {
            vueThat.$message.error('获取失败，请输入正确的手机号码')
            onOff = false
          }
        }
      } else if (type === 'email') {
        const regexp = new RegExp('^[a-z0-9A-Z]+[- | a-z0-9A-Z . _]+@([a-z0-9A-Z]+(-[a-z0-9A-Z]+)?\\.)+[a-z]{2,}$')
        if (!regexp.test(vueThat.user.new_email)) {
          vueThat.$message.error('获取失败，请输入正确的邮箱地址')
          onOff = false
        } else if (vueThat.user.code === '') {
          vueThat.$message.error('获取失败，请输入正确的手机验证码')
          onOff = false
        }
      }
      if (onOff) {
        vueThat.secondsCount[type] = 60
        // 切换倒计时按钮
        vueThat.isCodeShow[type] = false
        // 倒计时函数
        const timer = setInterval(function () {
          vueThat.secondsCount[type]--
          if (vueThat.secondsCount[type] <= 0) {
            clearInterval(timer)
            vueThat.isCodeShow[type] = true
          }
        }, 1000)
      }
      return onOff
    },
    // 获取验证码
    obtain (type) {
      if (this.codeTime(type)) {
        const vueThat = this
        const emailData = {
          number: vueThat.user.tel,
          tel_code: vueThat.user.code,
          type: 'personal',
          email: vueThat.user.new_email,
          user_name: vueThat.$store.state.user.info.name
        }
        const oldTel = {
          number: vueThat.user.tel,
          type: 'personal'
        }
        const newTel = {
          number: vueThat.user.new_tel,
          type: 'personal'
        }
        switch (type) {
          case 'security':
            vueThat.myApi.send(oldTel).then((res) => {
              if (res.data.code === 200) {
                vueThat.$message.success('验证码已发送')
              }
            })
            break
          case 'tel':
            vueThat.myApi.send(newTel).then((res) => {
              if (res.data.code === 200) {
                vueThat.$message.success('验证码已发送')
              }
            })
            break
          case 'email':
            vueThat.myApi.sendEmail(emailData).then((res) => {
              if (res.data.code === 200) {
                vueThat.$message.success('验证码已发送至邮箱' + vueThat.user.new_email)
              }
            })
            break
        }
      }
    },
    // 提交
    async submitForm (formName) {
      const vueThat = this
      vueThat.$refs[formName].validate(async (valid) => {
        if (valid) {
          const accountNameInfo = { // 更换手机绑定所需参数
            code: vueThat.user.code, // 旧手机验证码
            account_name: vueThat.user.account_name // 账号
          }
          const passwordInfo = { // 更换手机绑定所需参数
            code: vueThat.user.code, // 旧手机验证码
            password: vueThat.user.password, // 新密码
            repeat_password: vueThat.user.repeat_password // 确认密码
          }
          const telData = { // 更换手机绑定所需参数
            old_tel: vueThat.user.tel, // 旧手机号
            tel: vueThat.user.new_tel, // 新手机号
            old_code: vueThat.user.code, // 旧手机验证码
            code: vueThat.user.telCode // 新手机验证码
          }
          const emailData = { // 修改邮箱需要的参数
            email: vueThat.user.new_email, // 邮箱
            code: vueThat.user.emailCode // 邮箱验证码
          }
          switch (vueThat.dialogType) {
            case 'accountName':
              vueThat.myApi.addAccountName(accountNameInfo).then((res) => {
                if (res.data.code === 200) {
                  vueThat.$message.success('账号设置成功！')
                  vueThat.dialogSecurity = false
                }
              })
              break
            case 'password':
              vueThat.myApi.editPassword(passwordInfo).then((res) => {
                if (res.data.code === 200) {
                  vueThat.$message.success('密码修改成功！')
                  vueThat.dialogSecurity = false
                }
              })
              break
            case 'tel':
              vueThat.myApi.editBindTel(telData).then((res) => {
                if (res.data.code === 200) {
                  vueThat.$message.success('手机绑定更换成功！')
                  vueThat.user.tel = vueThat.user.new_tel
                  vueThat.user.code = ''
                  vueThat.user.new_tel = ''
                  vueThat.user.telCode = ''
                  vueThat.dialogSecurity = false
                }
              })
              break
            case 'email':
              vueThat.myApi.checkingEmail(emailData).then((res) => {
                if (res.data.code === 200) {
                  vueThat.$message.success('邮箱绑定成功！')
                  vueThat.user.email = vueThat.user.new_email
                  vueThat.user.emailCode = ''
                  vueThat.user.new_email = ''
                  vueThat.dialogSecurity = false
                }
              })
              break
          }
        }
      })
    },
    // 弹窗重置表单
    closeDialog (formName) {
      this.$refs[formName].resetFields()
    },
    // 第三方平台绑定
    bindThree (type) {
      const vueThat = this
      const url = 'http://' + window.location.host
      const weChat = url + '/weChatCallback'
      const weibo = url + '/weiboCallback'
      switch (type) {
        case 'weixin':
          window.location.href = 'https://open.weixin.qq.com/connect/qrconnect?appid=wxb7460c3667c6e927&redirect_uri=' + vueThat.mycommon.getUrlEncode(weChat) + '&response_type=code&scope=snsapi_login'
          break
        case 'weibo':
          window.location.href = 'https://api.weibo.com/oauth2/authorize?client_id=3265476805&response_type=code&redirect_uri=' + weibo
          break
        case 'qq':
          vueThat.$message.error('平台暂不支持QQ绑定！')
          break
      }
    },
    // 第三方平台账号解绑
    unBind (type) {
      const vueThat = this
      vueThat.myApi.unbundlingTripartite({ type: type }).then(res => {
        if (res.data.code === 200) {
          vueThat.$message.success('您已成功解绑！')
          vueThat.user[type] = null
        }
      })
    }
  }
}
</script>

<style scoped="scoped">
  .personal_edit_passWord_box{
    width: 400px;
    margin: 0 auto;
  }
</style>
